<template>
    <svg width="47" height="75" viewBox="0 0 47 75" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2279_973)">
            <path opacity="0.2"
                d="M44.5956 25.1887V64.9114C44.5956 72.1411 38.795 72.5708 31.6404 72.5708H2.40442C26.1148 70.0642 44.5956 49.8066 44.5956 25.1887Z"
                fill="#C43A4F" />
            <path
                d="M40.2286 2.4292H6.77141C4.35959 2.4292 2.40442 4.40449 2.40442 6.84114V68.159C2.40442 70.5956 4.35959 72.5709 6.77141 72.5709H40.2286C42.6404 72.5709 44.5956 70.5956 44.5956 68.159V6.84114C44.5956 4.40449 42.6404 2.4292 40.2286 2.4292Z"
                stroke="#C43A4F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.6964 63.4783H29.3036" stroke="#C43A4F" stroke-width="3" stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_2279_973">
                <rect width="47" height="75" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>